import { useContext, useState } from "react";
import { useChangePasswordRequest } from "src/services/user/commands/change_password";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../context";
import { ChangePasswordFormValues } from "../hooks/useChangePasswordForm";

const useChangePassword = () => {
	const [isLoading, setIsLoading] = useState(false);

	const { mutate } = useChangePasswordRequest();
	const { onClose } = useContext(Context);

	const onSuccess = () => {
		setIsLoading(false);
		SnackbarUtils.success("Contraseña cambiada con éxito.");
		onClose();
	};

	const onError = ({ response }: any, onSetError: any) => {
		setIsLoading(false);
		if (response?.data?.message === "bad_credentials") {
			onSetError("oldPassword", { message: "AUTH_06" });
		} else
			SnackbarUtils.error(
				"Hemos tenido problemas al intentar cambiar tu contraseña, por favor vuelve a intentarlo más tarde."
			);
	};

	const changePassword = (
		{ newPassword, oldPassword }: ChangePasswordFormValues,
		onSetError: any
	) => {
		setIsLoading(true);
		mutate(
			{ newPassword, oldPassword },
			{
				onSuccess,
				onError: (error) => onError(error, onSetError)
			}
		);
	};

	return {
		changePassword,
		isLoading
	};
};

export default useChangePassword;
